// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {DialpadLogo} from '@app/assets/logos';

export const Copyright = () => {
    return (
        <div className="copyright-container">
            <div className="copyright-wrapper">
                <div className="copyright-logo">
                    <DialpadLogo width={250} height={72} color="#6C3DFF" />
                </div>
                <div className="copyright-title">
                    <h1>PATENT NOTICE</h1>
                </div>
                <div className="copyright-body">
                    <div className="copyright-body__text">
                        <div>
                            <p>
                                Copyright (c) 2021, DIALPAD INC., all rights
                                reserved.
                            </p>

                            <p>Patented technology.</p>
                            <ul>
                                <li>U.S. Pat. No. 10,891,549 (US10891549B2)</li>
                                <li>U.S. Pat. No. 10,893,011 (US10893011B2)</li>
                                <li>U.S. Pat. No. 10,860,796 (US10860796B2)</li>
                            </ul>
                            <p>Additional patents pending.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
